import 'Utils/mere.js';
import 'readmore-js';
import { searchbarFixedHeight } from 'Utils/ha-searcbar-functions';
import { updateUI } from 'SrcJS/script--updateUI';

AppLoader.ready(function () {

    let moreLink = $('#pageIntro #moreLink').html();
    let lessLink = $('#pageIntro #lessLink').html();

    let readmore_speed = 100;
    $('#pageIntro .readmoreHeight').readmore({
        selector: '#pageIntro .readmoreHeight',
        speed: readmore_speed,
        collapsedHeight: 300,
        heightMargin: 26,
        embedCSS: false,
        //moreLink: '<a href="#" class="mere mere-link">@(txtReadMore)</a>',
        //lessLink: '<a href="#" class="mere mere-link expanded">@(Html.Translate(TranslationKeys.HotelPage.ShowLess))</a>',
        moreLink: moreLink,
        lessLink: lessLink,
        beforeToggle: function (trigger, element, expanded) {
            console.log('>>> beforeToggle >> ' + expanded);
            //let $fadeout = element.next('#fadeout');
            //if ($fadeout && $fadeout.length > 0) {
            //    $fadeout.css("display", expanded ? "block" : "none");
            //}
        },
        afterToggle: function (trigger, element, expanded) {
            console.log('>>> afterToggle >> ' + expanded);
            if (!expanded) { // The "Close" link was clicked
                $('html, body').stop().animate({
                    scrollTop: element.offset().top - searchbarFixedHeight()
                }, readmore_speed);
            }
            AppLoader.raf(function () {
                updateUI();
            }, readmore_speed + 32);
        }
    }).removeClass('readmore-placeholder');
});